import * as React from "react";
import { useLocation } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { StorageKeys } from "utils/Authentication";
import { getSessionMetadata } from "../../utils/Helpers";

export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const RetrievalsCallbackContainer: React.FC<{}> = () => {
  const [redirectTo, setRedirectTo] = React.useState<string>();

  const query = useQuery();
  const state = query.get("state");

  React.useEffect(() => {
    const sessionMetadata = getSessionMetadata();
    const appId = sessionStorage.getItem(StorageKeys.AppId);
    if (sessionMetadata?.sessionId && state) {
      const redirectPrefix = `/session/${sessionMetadata?.sessionId}/recover?state=${state}`;

      const errorCode = query.get("errorCode");
      setRedirectTo(
        !!errorCode
          ? `${redirectPrefix}&errorCode=${errorCode}`
          : redirectPrefix
      );
    } else if(appId){
      const redirectPrefix = `/me/apps/${appId}/recover?state=${state}`;

      const errorCode = query.get("errorCode");
      setRedirectTo(
        !!errorCode
          ? `${redirectPrefix}&errorCode=${errorCode}`
          : redirectPrefix
      );
    }
  }, [state, query]);

  return <>{redirectTo && <Redirect to={redirectTo} />}</>;
};

export default RetrievalsCallbackContainer;
